<template>
  <div class="flex justify-center" :class="center ? 'min-h-screen items-center' : 'pt-20'">
    <div class="animate-spin rounded-full border-b-2 border-blue-600" :class="sizeClass"></div>
  </div>
</template>

<script>
export default {
  name: "PageLoader",
  props: {
    // Vertically center in the viewport instead of sitting near the top.
    center: {
      type: Boolean,
      default: false,
    },
    // sm | md | lg
    size: {
      type: String,
      default: "md",
    },
  },
  computed: {
    sizeClass() {
      return { sm: "h-6 w-6", md: "h-12 w-12", lg: "h-16 w-16" }[this.size] || "h-12 w-12";
    },
  },
};
</script>
